"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useMouseDown = function (_a) {
    var ref = _a.ref, initValue = _a.initValue;
    var _b = (0, react_1.useState)(false), inputPressed = _b[0], setInputPressed = _b[1];
    var MouseDownHandler = function () {
        setInputPressed(true);
    };
    var MouseUpHandler = function () {
        setInputPressed(false);
    };
    (0, react_1.useEffect)(function () {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var el = ref === null || ref === void 0 ? void 0 : ref.current;
        if (el) {
            el.addEventListener('mousedown', MouseDownHandler);
            el.addEventListener('mouseup', MouseUpHandler);
            return function () {
                window.removeEventListener('mousedown', MouseDownHandler);
                window.removeEventListener('mouseup', MouseUpHandler);
            };
        }
    }, [initValue, ref]);
    return inputPressed;
};
exports.default = useMouseDown;
